import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

const { carbon, midnight } = colorsPalettes;

export const Text = styled.span<{ isDisabled: boolean }>`
    color: ${({ isDisabled }) => (isDisabled ? midnight[100] : carbon[500])};
`;
